import { Controller } from '@hotwired/stimulus';

// FIXME: jquery に依存しない構成に変更
export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.scrollY = 0;
  }

  // action="click->hamburger-menu#toggle"
  toggle({ currentTarget }) {
    currentTarget.classList.toggle('is-open');

    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('is-open');
    }

    if (currentTarget.classList.contains('is-open')) {
      currentTarget.classList.remove('is-close');
      this.#fixed();
    } else {
      currentTarget.classList.add('is-close');
      this.#release();
    }
  }

  #fixed() {
    this.scrollY = $(window).scrollTop();
    $(this.element).css({
      position: 'fixed',
      width: '100%',
      top: -1 * this.scrollY,
    });
  }

  #release() {
    $(this.element).css({
      position: 'relative',
      width: '',
      top: '',
    });
    $(window).scrollTop(this.scrollY);
  }
}
